export const colunas = [
  {
    title: "Login",
    dataIndex: "Login",
    key: "Login",
  },
  {
    title: "Ativo?",
    dataIndex: "Ativo",
    key: "Ativo",
    render: (Ativo: boolean) => {
      return (
        <span>
          {Ativo ? 'Ativo' : 'Inativo'}
        </span>
      )
    }
  },
];
